var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay", attrs: { id: "overlay" } }, [
    _c(
      "div",
      { staticClass: "overlay__wrapper", attrs: { id: "overlay-wrapper" } },
      [
        _c(
          "div",
          { staticClass: "overlay__content", attrs: { id: "overlay-content" } },
          [
            _c(
              "ul",
              {
                staticClass:
                  "modal__content-list modal__content-list--autowidth",
                attrs: { id: "modal-content" }
              },
              [
                _c(
                  "li",
                  {
                    staticClass:
                      "modal__content-item modal__content-item--close"
                  },
                  [
                    _c("span", {
                      staticClass: "modal__close",
                      attrs: { id: "modal-close" },
                      on: { click: _vm.closeErrorModal }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: {
                      "modal__content-item modal__content-item--content": true,
                      "modal__content-item--padconsistent":
                        this.errors.countError0 > 0
                    }
                  },
                  [
                    this.errors.countError0 > 0
                      ? _c("UploadError", {
                          attrs: {
                            configdata: _vm.configdata,
                            errorCount: this.errors.countError0,
                            errorMessage: this.errors.ErrorMessage0,
                            errorFiles: this.errors.ErrorArray0,
                            errorType: 0
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.errors.countError1 > 0
                      ? _c("UploadError", {
                          attrs: {
                            configdata: _vm.configdata,
                            errorCount: this.errors.countError1,
                            errorMessage: this.errors.ErrorMessage1,
                            errorFiles: this.errors.ErrorArray1,
                            errorType: 1
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.errors.countError2 > 0
                      ? _c("UploadError", {
                          attrs: {
                            configdata: _vm.configdata,
                            errorCount: this.errors.countError2,
                            errorMessage: this.errors.ErrorMessage2,
                            errorFiles: this.errors.ErrorArray2,
                            errorType: 2
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.errors.countError3 > 0
                      ? _c("UploadError", {
                          attrs: {
                            configdata: _vm.configdata,
                            errorCount: this.errors.countError3,
                            errorMessage: this.errors.ErrorMessage3,
                            errorFiles: this.errors.ErrorArray3,
                            errorType: 3
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.errors.countError4 > 0
                      ? _c("UploadError", {
                          attrs: {
                            configdata: _vm.configdata,
                            errorCount: this.errors.countError4,
                            errorMessage: this.errors.ErrorMessage4,
                            errorFiles: this.errors.ErrorArray4,
                            errorType: 4
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    this.errors.attachment == 1
                      ? _c("p", { staticClass: "modal__attachments_warning" }, [
                          _vm._v(
                            "\n            Bitte verwenden Sie für Anhänge ausschließlich das Format PDF\n          "
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal__control_action" }, [
                      _c("p", { staticClass: "modal__control_actionwrapper" }, [
                        _c(
                          "span",
                          {
                            staticClass:
                              "modal__control_cancel modal-close-action modal__error-button",
                            on: { click: _vm.closeErrorModal }
                          },
                          [
                            this.errors.countAccepted > 0 &&
                            this.errors.attachment != 1
                              ? _c("span", [_vm._v("weiter")])
                              : _c("span", [_vm._v("ok")])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    this.errors.countError0 > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "notice notice--lightgreen notice--modal"
                          },
                          [
                            _c("p", { staticClass: "notice__title" }, [
                              _c("span", { staticClass: "notice__titlehint" }, [
                                _vm._v("Hinweis")
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    this.lang["ErrorType0Title"]
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(this.lang["ErrorType0Par1"])
                              }
                            }),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(this.lang["ErrorType0Par2"])
                              }
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "cta cta--medium cta--modify cta--maxw280-auto",
                                  attrs: {
                                    href: this.config.routes
                                      .ebrief_enquiry_ftpadmission
                                  }
                                },
                                [
                                  _c("span", { staticClass: "cta__wrapper" }, [
                                    _c("span", { staticClass: "cta__icon" }, [
                                      _vm._v("  ")
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "cta__text",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          this.lang["ErrorType0CtaText"]
                                        )
                                      }
                                    })
                                  ])
                                ]
                              )
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }